import { z } from 'zod';

export interface TaskVisibilityCandidate {
  id?: unknown;
  assignee?: string | null;
}

function hasTaskId(
  task: TaskVisibilityCandidate | null | undefined,
): task is TaskVisibilityCandidate & { id: string } {
  return taskIdSchema.safeParse(task?.id).success;
}

const taskIdSchema = z.string();

export function isTaskVisibleToCurrentUser(
  task: TaskVisibilityCandidate | null | undefined,
  currentUserId: string | null | undefined,
): boolean {
  return hasTaskId(task)
    && (task.assignee === currentUserId || !task.assignee);
}

export function countTasksVisibleToCurrentUser(
  tasks: readonly TaskVisibilityCandidate[],
  currentUserId: string | null | undefined,
): number {
  return tasks.filter((task) => isTaskVisibleToCurrentUser(task, currentUserId)).length;
}
